<template>
  <a-layout>
    <a-space>
      <a-button type="primary" @click="pickUp">{{$t('button.taken')}}</a-button>
      <a-popconfirm
        :title="$t('title.selectedDetailsWillBeDeleted')"
        @confirm="del">
        <a-button type="primary">{{$t('button.delete')}}</a-button>
      </a-popconfirm>
      <a-button :disabled="this.data.length===0" type="primary" @click="save">{{$t('button.save')}}</a-button>
      <a-button type="primary" @click="reset">{{$t('button.reset')}}</a-button>
      <vxe-select v-model="ownerId" :options="owners" placeholder="placeholder.pleaseSelectOwner" @change="onOwnerChange"/>
    </a-space>
    <a-divider>{{$t('divider.replenishmentDetail')}}</a-divider>
    <vxe-table
      border
      stripe
      round
      show-overflow
      show-header-overflow
      :export-config="{}"
      ref="table"
      align="center"
      :data="data"
      :loading="loading"
      :keyboard-config="{isArrow: true}"
      :scroll-x="{enabled: true}"
      :height="scrollY"
      size="mini"
      :row-config="{isCurrent: true, isHover: true}"
      :column-config="{resizable: true}"
      :checkbox-config="{trigger: 'row'}"
      keep-source
      :edit-rules="editRules"
      :edit-config="editConfig">
      <vxe-column fixed="left" type="checkbox" width="40"/>
      <vxe-column field="item.no" title="business.label.itemNo" width="80"/>
      <vxe-column field="item.name" title="business.label.itemName"/>
      <vxe-column field="pack.specification" title="business.label.specification"/>
      <vxe-column field="pack.uom" title="business.label.uom" width="60"/>
      <vxe-column field="pack.factor" title="business.label.factor" width="50"/>
      <vxe-column field="invQuantity" title="business.label.invQuantity"/>
      <vxe-column field="quantity" title="business.label.quantity"/>
      <vxe-column field="inventoryLimit.lowerBound" title="business.label.lowerBound"/>
      <vxe-column field="inventoryLimit.upperBound" title="business.label.upperBound"/>
      <vxe-column field="sourceStorageRoom.name" title="business.label.sourceStorageRoom"/>
      <vxe-column field="targetStorageRoom.name" title="business.label.targetStorageRoom"/>
      <vxe-column field="logicalStore.name" title="business.label.logicalStore"/>
      <vxe-column field="obtainedQuantity" title="title.replenishmentQuantity" :edit-render="{enable:true,autofocus: '.vxe-input--inner'}">
        <template #edit="{ row }">
          <vxe-input type="number"
                     v-model="row.obtainedQuantity"
                     :min="0"
                     align="center"
                     placeholder=""/>
        </template>
      </vxe-column>
    </vxe-table>
    <ActiveReplenishmentModal ref="activeReplenishmentModal" @change="change"/>
  </a-layout>
</template>

<script>
import Vue from 'vue'
import { OPERATOR, SCREEN_HEIGHT, WAREHOUSE } from '@/store/mutation-types'
import ActiveReplenishmentModal from '@/views/modal/ActiveReplenishmentModal.vue'
import { findAll, post } from '@/api/Api'
import Api from '@/api'

export default {
  name: 'ActiveReplenishment',
  components: { ActiveReplenishmentModal },
  props: {
    queryParam: { type: Object, default: null }
  },
  data() {
    return {
      data: [],
      executor: Vue.ls.get(OPERATOR),
      warehouse: Vue.ls.get(WAREHOUSE),
      loading: false,
      owners: [],
      ownerId: undefined,
      scrollY: Vue.ls.get(SCREEN_HEIGHT) * (0.73),// 表格竖向滚动条
      editConfig: { trigger: 'click', mode: 'cell', showStatus: true },
      editRules: {
        obtainedQuantity: [
          { required: true, type: 'number', min: 1, message: '补货数量需大于0' }
        ]
      }
    }
  },
  mounted() {
    findAll('partyFactory', { available: true, 'type.ordinal': 1 }).then(res => {
      if (res.success) {
        this.owners = res.result
      }
    })
  },
  methods: {
    onOwnerChange() {
      if (this.data.length !== 0) {
        this.data = []
      }
    },
    pickUp() {
      if (!this.ownerId) {
        return this.$message.warning('请先选择货主')
      }
      this.$refs.activeReplenishmentModal.open({ 'owner.id': this.ownerId })
    },
    del() {
      this.$refs.table.removeCheckboxRow().then(() => {
        this.data = this.$refs.table.tableData
      })
    },
    save() {
      this.loading = true
      const order = {
        orderType: { id: this.queryParam.value.business.orderTypeId },
        owner: { id: this.ownerId },
        dataSource: 4,
        warehouse: { id: this.warehouse.id },
        details: []
      }
      this.data.forEach(item => {
        const detail = {
          item: { id: item.item.id },
          invoiceQuantity: item.obtainedQuantity,
          pack: { id: item.pack.id },
          storageRoom: { id: item.targetStorageRoom.id },
          logicalStore: { id: item.logicalStore.id }
        }
        order.details.push(detail)
      })
      post(Api.replenishingReplenish, { type: 'initiativeReplenisher' }, order).then(res => {
        if (res.success) {
          this.onSelectChange([], [])
          this.data = []
          this.$message.success('保存成功')
        }
      }).finally(() => this.loading = false)
    },
    reset() {
      this.data = []
      this.ownerId = undefined
    },
    change(pickupData) {
      this.data = pickupData
    }
  }
}
</script>
<style scoped>
.columnHeader {
  font-weight: bold;
  color: #404040;
}
</style>